<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
    <path
      d="M8.66667 7.35H4.66667M6 9.95H4.66667M10 4.75H4.66667M12.6667 7.025V4.62C12.6667 3.5279 12.6667 2.98185 12.4487 2.56472C12.2569 2.1978 11.951 1.89949 11.5746 1.71254C11.1468 1.5 10.5868 1.5 9.46667 1.5H5.2C4.0799 1.5 3.51984 1.5 3.09202 1.71254C2.71569 1.89949 2.40973 2.1978 2.21799 2.56472C2 2.98185 2 3.5279 2 4.62V11.38C2 12.4721 2 13.0182 2.21799 13.4353C2.40973 13.8022 2.71569 14.1005 3.09202 14.2875C3.51984 14.5 4.0799 14.5 5.2 14.5H7M14 14.5L13 13.525M13.6667 11.9C13.6667 13.1564 12.622 14.175 11.3333 14.175C10.0447 14.175 9 13.1564 9 11.9C9 10.6436 10.0447 9.625 11.3333 9.625C12.622 9.625 13.6667 10.6436 13.6667 11.9Z"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
